import Column from "@components/column";
import React from "react";

import UnitForm from "./form";
import UnitList from "./list";

const UnitSetup = () => {
  return (
    <Column>
      <UnitForm />
      <UnitList />
    </Column>
  );
};

export default UnitSetup;
